/**
 * @Descriptions util 工具
 */
import { phoneRegexp } from "./constant";

import { platform } from './dingtalk'

/**
 * @description 判断操作系统是Android/iOS
 * @returns String [android|iOS|unknow]
 */
export function checkPlatform() {
  let userAgent = navigator.userAgent;
  let isAndroid =
    userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1; //android终端
  let isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) return "android";
  else if (isiOS) return "iOS";
  else return "unknow";
}

/**
 * 补零 不满10 进行补零
 * @param {number} n 小于10的数字
 * @returns String  number + ''
 */
export const fZero = (n) => (n > 9 ? `${n}` : `0${n}`);

/**
 *
 * @param {unknown} variable 一个不知道类型的变量
 * @returns {String} 返回变量类型(String/Number/Null/Undefined/...)
 */
export const getStringTye = (variable) =>
  Object.prototype.toString.call(variable, variable).split(" ")[1].slice(0, -1);

/**
 * 获取静态资源基本信息
 * @param {String} url 静态资源链接
 * @returns
 *      filename: 文件名称(无后缀)
 *      name: 文件名称 + 后缀
 *      suffix: 后缀
 *      path: 文件路径（不包含域名、文件名 + 后缀）
 *      domainName: 域名
 *      url: 输入
 */
export const getStaticLinkInfo = (url) => {
  // https://chaoting-washing.oss-cn-zhangjiakou.aliyuncs.com/dd808164257b2fc2/a729087658ff1ef0.pdf
  let regexp =
    /^(http[s]?:\/\/.*\.com)(.*?)(([\u4e00-\u9fa5\-\w\d\s.]*?)\.(\w*))$/i;
  let matchArrs = url.match(regexp);
  let name = "unknow";
  let suffix = "unknow";
  let path = "";
  let filename = "";
  let domainName = "";

  if (Array.isArray(matchArrs) && matchArrs.length) {
    const [, _domainName, _path, filenameAll, _filename, _suffix] = matchArrs;
    name = filenameAll;
    suffix = _suffix;
    path = _path;
    filename = _filename;
    domainName = _domainName;
  }

  return {
    filename,
    name,
    suffix,
    path,
    domainName,
    url,
  };
};

export const getFileNameSuffix = (filename) => {
  let regexp = /^[\u4e00-\u9fa5\-\w\d\s.]*?\.(\w*)$/i;
  let matchRes = filename.match(regexp);
  if (Array.isArray(matchRes) && matchRes.length) {
    const [, suffix] = matchRes;
    return suffix;
  }
  return "";
};

/**
 * 获取可视化的大小
 * @param {Number} size 字节大小
 */
export const getByteShowSize = (size) => {
  if (!size) return "";
  var num = 1024.0; //byte
  if (size < num) return size + "B";
  if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + "KB"; //kb
  if (size < Math.pow(num, 3))
    return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
  if (size < Math.pow(num, 4))
    return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
  return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
};

const checkRegexp = (regexp) => (str) => regexp.test(str);

/**
 * 检查手机号是否符合规范
 * @param {String} phonenumber
 * @returns {boolean}
 */
export const checkMobile = checkRegexp(phoneRegexp);

/**
 * 通过A链接的方式下载文件
 * @param {string} href 文件地址链接
 */
export const downloadFileUseATarget = (href) => {
  const { name, suffix } = getStaticLinkInfo(href);
  if (suffix === "pdf") {
    console.log('%c platform : >>>', 'background: blue; color: #fff', platform);
    if (platform === 'android') {
      androidDownloadPdf(href)
    } else if (platform === 'ios') {
      // androidDownloadPdf(href)
      window.location.href = href
    } else {
      download(href, name);
    }
  } else createAndRemove(href, name);
};

function androidDownloadPdf (url) {
  window.open(url)
}

export default function download(url, fileName) {
  const x = new XMLHttpRequest();
  x.open("GET", url, true);
  x.responseType = "blob";
  x.onload = () => {
    const url = window.URL.createObjectURL(x.response);
    createAndRemove(url, fileName);
    window.URL.revokeObjectURL(x.response)
  };
  x.send();
}

function createAndRemove(url, fileName) {
  // 创建隐藏的可下载链接
  var eleLink = document.createElement("a");
  eleLink.download = fileName;
  eleLink.style.display = "none";
  // 下载内容转变成blob地址
  eleLink.href = url;
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  document.body.removeChild(eleLink);
}
